module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid21_960x861.42ce3d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid21_960x861.jpg
// module id = dOQN
// module chunks = 0